export default "__VITE_ASSET__BMTG3fcr__"